import { useTranslation } from 'react-i18next';
import { RenderDataWithFallback, TableSegment, WithLoadingOverlay } from '@anytag/shared-atoms';
import { PostReportEmpty, PostReportTable, PostReportSegmentKeys } from '../../../PostReport';
import { EngagementReportChart } from '../EngagementReportChart';
import { EngagementReportTableDataProps, useEngagementReportTableData } from './hooks';

export const EngagementReportTable = (props: EngagementReportTableDataProps) => {
  const { t } = useTranslation();
  const { reportData, loading, segment, networkStatus, segmentStatus, handleSegmentChange } =
    useEngagementReportTableData(props);

  return (
    <RenderDataWithFallback
      loading={loading && networkStatus === 1} // maybe we should call initialLoading
      hasNoData={!reportData}
      noDataNode={<PostReportEmpty />}
    >
      {reportData ? (
        <WithLoadingOverlay loading={loading}>
          <EngagementReportChart data={reportData.chartData} socialMedias={props.engagement.socialMedias} />
          <TableSegment
            type="switch"
            className="report-table-segment"
            values={(Object.keys(segmentStatus) as PostReportSegmentKeys[]).filter((key) => segmentStatus[key])}
            onChange={handleSegmentChange}
            options={[
              {
                label: t('Total'),
                loading: segment.total.loading,
                value: PostReportSegmentKeys.total
              },
              {
                label: t('General.Influencer'),
                loading: segment.influencer?.loading,
                value: PostReportSegmentKeys.influencer
              },
              {
                label: t('General.Post'),
                loading: segment.post?.loading,
                value: PostReportSegmentKeys.post
              }
            ]}
          />
          <PostReportTable
            loading={loading}
            data={reportData}
            segment={segment}
            summaryData={props.summaryData}
            pagination={{ totalRecords: reportData.postCount }}
          />
        </WithLoadingOverlay>
      ) : null}
    </RenderDataWithFallback>
  );
};
